export default {
    SET_ITEMS(state, items) {
        state.items = items;
    },
    SET_SELECTED_THEMA_ID(state, themaId) {
        if(state.selectedThemaId === themaId) {
            return;
        }

        state.selectedThemaId = themaId;
    },
    SET_SORT_BY_KEY_OR_TOGGLE_ORDER(state, key) {
        if(state.sortBy.key === key) {
            state.sortBy.order = state.sortBy.order === 'asc' ? 'desc' : 'asc';
            return;
        }

        state.sortBy.key = key;
        state.sortBy.order = 'asc';
    },
    SET_SORT_BY(state, sortBy) {
        state.sortBy = sortBy;
    },
    SET_KONZESSIONSABGABEN(state, items) {
        state.konzessionsabgaben = items;
    },
    SET_KONZESSIONSABGABEN_FILTER_VALUES(state, values) {
        state.konzessionsabgabenFilterValues = {
            communes: values?.communes ?? [],
            documentTypes: values?.documentTypes ?? [],
            years: values?.years ?? []
        };
    },
    APPEND_KONZESSIONSABGABEN(state, items) {
        state.konzessionsabgaben = [...state.konzessionsabgaben, ...items];
    },
    SET_KONZESSIONSABGABEN_PAGINATION(state, pagination) {
        state.konzessionsabgabenPagination = {
            ...state.konzessionsabgabenPagination,
            ...pagination
        };
    },
    SET_KONZESSIONSABGABEN_LOADING(state, isLoading) {
        state.konzessionsabgabenLoading = isLoading;
    },
    MARK_AS_READ(state, osid) {
        const index = state.konzessionsabgaben.findIndex(item => item.osid === osid);
        console.log(index);
        if (index && index !== -1) {
            state.konzessionsabgaben[index].isNewEntry = false;
        }
    }
}
